import { Outlet } from '@tanstack/react-router'
import { useAccess } from '../access-context'
import { useLocale } from '../i18n'
import { problemText } from '../problems'
import { ForcedPasswordScreen } from './ChangePassword'
import { EnrollScreen } from './Enroll'
import { BootProblem, Splash } from './Frame'
import { LockScreen } from './Lock'
import { Shell } from './Shell'
import { SigningScreen } from './Signing'
import { UpdateScreen } from './Update'

/**
 * The gate: what the server says the device is decides the screen. Nothing
 * behind the lock is rendered, or fetched, until a session exists; the URL is
 * kept, so after the PIN the person is back where they were.
 */
export function Root() {
  const { access, bootProblem, retryBoot } = useAccess()
  const { locale, messages } = useLocale()
  if (bootProblem) {
    return <BootProblem retry={retryBoot} message={problemText(bootProblem, locale, messages)} />
  }
  switch (access.state) {
    case 'checking':
      return <Splash />
    case 'enroll':
      return <EnrollScreen reason={access.reason} />
    case 'locked':
      return <LockScreen reason={access.reason} />
    case 'unlocked':
      // S9: a password someone else chose is replaced before anything else. The address
      // stays, and opens once it is.
      if (access.session.passwordChangeRequired) return <ForcedPasswordScreen />
      return (
        <Shell>
          <Outlet />
        </Shell>
      )
    // CTR-2: turned to the customer. No Shell, no navigation; the URL stays for the PIN after.
    case 'signing':
      return <SigningScreen />
    // 426: this version of the app is too old for the API; nothing else can work.
    case 'update':
      return <UpdateScreen />
  }
}
